import { ProcedureBelongingsListInput } from "./procedure-belongings-list-input";

export const ProcedureSubmissionsListInput = ProcedureBelongingsListInput;
